import { Component, inject, OnInit } from '@angular/core';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, finalize, Subject, switchMap, takeUntil } from 'rxjs';
import { GetItemsParams, Patient } from '../service/appointments.model';
import { SharedService } from 'src/app/services/shared.service';
import { AppoinmentsService } from '../service/appoinments.service';
import { ApiService } from 'src/app/services/api.service';
import { ToastService } from 'src/app/services/toast.service';
import { CaseType, ToastType } from 'src/app/enums/enums';

@Component({
  selector: 'app-neurologist',
  templateUrl: './neurologist.component.html',
  styleUrls: ['./neurologist.component.scss']
})
export class NeurologistComponent implements OnInit {
  calendar = inject(NgbCalendar);
  private Unsubscribe = new Subject<void>();
  public PaginationParams!: GetItemsParams;
  public IsLoading = false;
  public TotaReports = 0;
  public reportList: any[] = [];
  fromDate: NgbDate | null = this.calendar.getToday();
  fromStr = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
  toDate: NgbDate | null = this.calendar.getNext(this.calendar.getToday(), 'd', 10);
  toStr = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;
  private SearchSubject = new Subject<string>();
  public SearchVal: string = '';
  currentClinic = 0;
  isLoading = false;

  constructor(public sharedService: SharedService, private appoinmentsService: AppoinmentsService, public apiService: ApiService, private toast: ToastService) {
    this.PaginationParams = {
      searchValue: '',
      sortColumn: 'firstName',
      clinicId: this.sharedService.CurrentClinic.value || 0,
      sortOrder: 'asc',
      fromDate: this.fromStr,
      toDate: this.toStr
    };
  }
  ngOnInit(): void {
    this.currentClinic = this.sharedService.CurrentClinic.value || 0;
    this.SearchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) => {
        this.PaginationParams.searchValue = term;
        this.GetNeuroAppointmentReport(this.PaginationParams);
        return '';
      })
    ).subscribe((results) => {});
    this.sharedService.CurrentClinic.pipe(takeUntil(this.Unsubscribe)).subscribe((val) => {
      this.PaginationParams.clinicId = Number(val);
      this.currentClinic = Number(val);
      this.GetNeuroAppointmentReport(this.PaginationParams);
    });
  }

  GetNeuroAppointmentReport(params: GetItemsParams) {
    this.IsLoading = true;
    this.appoinmentsService.getAppoinmentReport(params, 'NeuroAppointmentReport').subscribe({
      next: (res) => {
        this.reportList = [...res.result.appointmentReportData];
        this.reportList.map((report) => {
          report.patientData.map((patient: Patient) => {
            patient.clinicName = this.apiService.GetClinicName(patient.clinicId);
            patient.caseName = this.getCaseName(patient.caseType);
          });
        });
        this.TotaReports = this.reportList.length;
      },
      error: (err) => {
        this.IsLoading = false;
      },
      complete: () => (this.IsLoading = false)
    });
  }

  toDateChange(date: string) {
    this.toStr = date;
    this.PaginationParams.toDate = date;
    this.GetNeuroAppointmentReport(this.PaginationParams);
  }

  fromDateChange(date: string) {
    this.PaginationParams.fromDate = date;
    this.fromStr = date;
  }

  exportReport(): void {
    this.isLoading = true;
    this.appoinmentsService
      .exportAppoinmentReport(this.PaginationParams, 'ExportNeuroAppointmentReport')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (blob: Blob) => {
          const fileName = `NeuroAppointmentReport_${this.PaginationParams.fromDate}_to_${this.PaginationParams.toDate}.pdf`;

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Error during file download:', err);
          alert('Failed to download the report. Please try again.');
        }
      });
  }

  SortData(sortBy: string) {
    this.PaginationParams.sortColumn = sortBy;
    this.PaginationParams.sortOrder = this.PaginationParams.sortOrder === 'asc' ? 'desc' : 'asc';
    this.GetNeuroAppointmentReport(this.PaginationParams);
  }

  getCaseName(id: number): string {
    return CaseType[id] || '';
  }

  SearchData() {
    this.SearchSubject.next(this.SearchVal);
  }

  ngOnDestroy(): void {
    this.Unsubscribe.next();
    this.Unsubscribe.complete();
  }
}
